import { USER_PREMIUM, USER_MARKETS_CORP } from 'constants/user-roles'
import {
  SECTION_LEGISLATION,
  SECTION_MAPPINGS,
  SECTION_MARKETS,
  SECTION_NEWS,
  SECTION_PRECEDENTS,
  SECTION_QA
} from './sections'
import {
  QA_MENU,
  QA_CONTENT,
  LEGISLATION,
  LEGISLATION_FOLDERS,
  CURRENT_AWARENESS,
  DASHBOARD,
  PRECEDENTS,
  PRECEDENTS_CONTENT,
  MW_OVERVIEW
} from 'constants/controllers'
import { DEFAULT_FLAVOUR } from 'constants/flavours'
import { AOLConfig } from 'interfaces/aol'
import { URL_FC_TRAINING_SIGN_IN, URL_TRAINING } from 'constants/links'

 const aolConfig:AOLConfig[] = [
  {
    name: '',
    urlFragment: '',
    sections: [],
    menus: {
      headerNav: [],
      search: [],
      footer: []
    }
  },
  {
    name: 'Corporate',
    urlFragment: 'corporate',
    sections: [
      {
        section: SECTION_NEWS,
        availableToRoles: [] // empty indicates all users
      },
      {
        section: SECTION_QA,
        availableToRoles: [],
        parameters: {
          flavours: ['full', 'semi', 'skimmed', 'archive']
        }
      },
      {
        section: SECTION_LEGISLATION,
        availableToRoles: []
      },
      {
        section: SECTION_PRECEDENTS,
        availableToRoles: []
      },
      {
        section: SECTION_MARKETS,
        availableToRoles: [USER_PREMIUM, USER_MARKETS_CORP]
      }
    ],
    menus: {
      headerNav: [
        {
          title: 'News',
          target: DASHBOARD,
          params: {},
          activeClass: 'light-sea-green-2',
          availableToRoles: [],
          highlightPages: SECTION_MAPPINGS[SECTION_NEWS], // this field and the next is to support easier header nav highlighting
          searchType: 'ca'
        },
        {
          title: 'Q&A',
          target: QA_MENU,
          params: {},
          activeClass: 'medium-turquoise',
          availableToRoles: [],
          highlightPages: SECTION_MAPPINGS[SECTION_QA],
          searchType: 'qa'
        },
        {
          title: 'Legislation',
          target: LEGISLATION_FOLDERS,
          params: {},
          activeClass: 'dark-orchid',
          availableToRoles: [],
          highlightPages: SECTION_MAPPINGS[SECTION_LEGISLATION],
          searchType: 'legislation'
        },
        {
          title: 'Documents',
          target: PRECEDENTS_CONTENT,
          params: { view: 'browse' },
          activeClass: 'teal',
          availableToRoles: [],
          highlightPages: SECTION_MAPPINGS[SECTION_PRECEDENTS],
          searchType: 'precedents'
        },
        {
          title: 'Markets',
          target: MW_OVERVIEW,
          params: {},
          activeClass: 'dark-sea-green-3',
          availableToRoles: [USER_PREMIUM, USER_MARKETS_CORP],
          highlightPages: SECTION_MAPPINGS[SECTION_MARKETS]
        },
        {
          title: 'Training',
          url: URL_FC_TRAINING_SIGN_IN,
          alternativeUrl: URL_TRAINING,
          params: {},
          activeClass: 'chocolate',
          availableToRoles: [],
          externalLink: true,
          isNew: true
        }
      ],
      search: [
        {
          title: 'Q&A',
          target: QA_CONTENT,
          params: {},
          typeName: 'qa',
          activeClass: 'qa-search-button',
          icon: 'icon-qa-search-variant',
          availableToRoles: []
        },
        {
          title: 'Legislation',
          target: LEGISLATION,
          position: 'search',
          params: { flavour: DEFAULT_FLAVOUR },
          typeName: 'legislation',
          activeClass: 'legislation-search-button',
          icon: 'icon-legislation-search-variant',
          availableToRoles: []
        },
        {
          title: 'News',
          target: CURRENT_AWARENESS,
          params: {},
          typeName: 'ca',
          activeClass: 'news-search-button',
          icon: 'icon-news-archive-search-variant',
          availableToRoles: []
        },
        {
          title: 'Documents',
          target: PRECEDENTS,
          params: { view: 'browse' },
          typeName: 'precedents',
          activeClass: 'precedents-search-button',
          icon: 'icon-precedents-search-variant',
          availableToRoles: []
        },
        {
          title: 'Markets',
          target: 'dealwatch', // not entirely sure why this isn't a constant, leaving as is for now
          position: 'search',
          params: {},
          typeName: 'dealwatch',
          activeClass: 'markets-search-button',
          icon: 'icon-markets-search-variant',
          availableToRoles: [USER_PREMIUM, USER_MARKETS_CORP]
        }
      ],
      footer: [ // for under the product header
        {
          title: 'Q&A',
          target: QA_MENU,
          params: {},
          availableToRoles: []
        },
        {
          title: 'Legislation',
          target: LEGISLATION_FOLDERS,
          params: {},
          availableToRoles: []
        },
        {
          title: 'News',
          target: CURRENT_AWARENESS,
          params: {},
          availableToRoles: []
        },
        {
          title: 'Documents',
          target: PRECEDENTS_CONTENT,
          params: { view: 'browse' },
          availableToRoles: []
        },
        {
          title: 'Markets',
          target: MW_OVERVIEW,
          params: {},
          availableToRoles: [USER_PREMIUM, USER_MARKETS_CORP]
        },
        {
          title: 'Training',
          target: URL_FC_TRAINING_SIGN_IN,
          alternativeUrl: URL_TRAINING,
          availableToRoles: []
        }
      ]
    }
  },
  {
    name: 'Employment',
    urlFragment: 'employment',
    sections: [
      {
        section: SECTION_NEWS,
        availableToRoles: [] // empty indicates all users
      },
      {
        section: SECTION_QA,
        availableToRoles: [],
        parameters: {
          flavours: ['full', 'skimmed', 'archive']
        }
      },
      {
        section: SECTION_LEGISLATION,
        availableToRoles: []
      }
    ],
    menus: {
      headerNav: [
        {
          title: 'News',
          target: DASHBOARD,
          params: {},
          activeClass: 'black',
          availableToRoles: [],
          highlightPages: SECTION_MAPPINGS[SECTION_NEWS],
          searchType: 'ca'
        },
        {
          title: 'Q&A',
          target: QA_MENU,
          params: {},
          activeClass: 'light-sea-green-2',
          availableToRoles: [],
          highlightPages: SECTION_MAPPINGS[SECTION_QA],
          searchType: 'qa'
        },
        {
          title: 'Legislation',
          target: LEGISLATION_FOLDERS,
          params: {},
          activeClass: 'dark-orchid',
          availableToRoles: [],
          highlightPages: SECTION_MAPPINGS[SECTION_LEGISLATION],
          searchType: 'legislation'
        }
      ],
      search: [
        {
          title: 'Q&A',
          target: QA_CONTENT,
          params: {},
          typeName: 'qa',
          activeClass: 'qa-search-button',
          icon: 'icon-qa-search-variant',
          availableToRoles: []
        },
        {
          title: 'Legislation',
          target: LEGISLATION,
          position: 'search',
          params: { flavour: DEFAULT_FLAVOUR },
          typeName: 'legislation',
          activeClass: 'legislation-search-button',
          icon: 'icon-legislation-search-variant',
          availableToRoles: []
        },
        {
          title: 'News',
          target: CURRENT_AWARENESS,
          params: {},
          typeName: 'ca',
          activeClass: 'news-search-button',
          icon: 'icon-news-archive-search-variant',
          availableToRoles: []
        }
      ],
      footer: [ // for under the product header
        {
          title: 'Q&A',
          target: QA_MENU,
          params: {},
          availableToRoles: []
        },
        {
          title: 'Legislation',
          target: LEGISLATION_FOLDERS,
          params: {},
          availableToRoles: []
        },
        {
          title: 'News',
          target: CURRENT_AWARENESS,
          params: {},
          availableToRoles: []
        },
        {
          title: 'Documents',
          target: PRECEDENTS_CONTENT,
          params: { view: 'browse' },
          availableToRoles: []
        }
      ]
    }
  }
]

export default aolConfig;
